import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import updateSingleDatasetInView from './updateSingleDatasetInView';
export default function updateMultipleDatasetsInView(view, data) {
  var _context;

  _forEachInstanceProperty(_context = _Object$keys(data)).call(_context, function (name) {
    updateSingleDatasetInView(view, name, data[name]);
  });
}